module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAACCAIAAAAIKhHDAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAABVJREFUeNpi1NPTYyAaMDGQAgACDAAxmACOsmGDkAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/remove_symbol.png
// module id = 895
// module chunks = 438